export enum ApiServiceType {
  Analytics = 'analytics',
  ControlPlane = 'cp',
  Notification = 'ns',
  Collector = 'cl',
  ConversionService = 'cs',
  Markout = 'mr',
  Clp = 'clp',
}
